export enum DefaultVendorPrioritizations {
  SITE_ASSIGNMENT = 'site_assignment',
  RATE_ASSIGNMENT = 'rate_assignment'
}
